'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'rotate';
var width = 512;
var height = 512;
var aliases = [128260,"sync-alt"];
var unicode = 'f2f1';
var svgPathData = ['M16 376l0 112c0 3.2 1.9 6.2 4.9 7.4s6.4 .6 8.7-1.7l112-112c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9L24 368c-4.4 0-8 3.6-8 8zM368.6 139.1c1.2 3 4.2 4.9 7.4 4.9l112 0c4.4 0 8-3.6 8-8l0-112c0-3.2-1.9-6.2-4.9-7.4s-6.4-.6-8.7 1.7l-112 112c-2.3 2.3-3 5.7-1.7 8.7z', 'M376 144c-3.2 0-6.2-1.9-7.4-4.9s-.6-6.4 1.7-8.7l112-112c2.3-2.3 5.7-3 8.7-1.7S496 20.8 496 24l0 112c0 4.4-3.6 8-8 8l-112 0zm0 16l112 0c13.3 0 24-10.7 24-24l0-112c0-9.7-5.8-18.5-14.8-22.2S477.9 .2 471 7L419.3 58.8C318.7-24.7 169.2-19.3 75 75 27.1 122.8 2.2 184.9 .1 247.6 0 252 3.5 255.7 7.9 255.9s8.1-3.3 8.3-7.7c1.9-58.8 25.3-117 70.2-161.9 88-88 227.3-93.4 321.6-16.1L359 119c-6.9 6.9-8.9 17.2-5.2 26.2S366.3 160 376 160zM136 368c3.2 0 6.2 1.9 7.4 4.9s.6 6.4-1.7 8.7l-112 112c-2.3 2.3-5.7 3-8.7 1.7S16 491.2 16 488l0-112c0-4.4 3.6-8 8-8l112 0zm0-16L24 352c-13.3 0-24 10.7-24 24L0 488c0 9.7 5.8 18.5 14.8 22.2S34.1 511.8 41 505l51.8-51.8c100.6 83.5 250 78.1 344.3-16.2 47.8-47.8 72.8-109.9 74.8-172.6 .1-4.4-3.3-8.1-7.7-8.3s-8.1 3.3-8.3 7.7c-1.9 58.8-25.3 117-70.2 161.8-88 88-227.3 93.4-321.6 16.1L153 393c6.9-6.9 8.9-17.2 5.2-26.2S145.7 352 136 352z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRotate = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;